

import { Asset } from "../../../models/assets.model.ts";
import { Comment } from "../../../models/comment.model.ts";
import { CommentSerializer } from "../../../models/serializers/CommentSerializer.ts";
import { httpRequest } from "../../http";

export class CommandPostComment {
    async run( organizationId:number, todoId:number, comment: string, files:Asset[]) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/todos/${todoId}/comments/`;
       
        try {
            //make it as form data
            const formData = new FormData();
            formData.append("data", JSON.stringify({
                organization: {
                    id: organizationId,
                },
                body: comment,
            }));
            if(files) {
                files.forEach((file) => {
                    formData.append("files", file.file as File);
                });
            }  
            const response = await httpRequest<any>(url, {
                method: "POST",
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                body: formData
                   
            });
            return this.deserialize(response.comments);
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) : Comment[]{
        const serializer = new CommentSerializer();
        return serializer.deserializeList(data);
    }
}

